import { render } from "./Tune.vue?vue&type=template&id=c7a9e918"
import script from "./Tune.vue?vue&type=script&lang=js"
export * from "./Tune.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Tune.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7a9e918"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7a9e918', __exports__)) {
    api.reload('c7a9e918', __exports__)
  }
  
  module.hot.accept("./Tune.vue?vue&type=template&id=c7a9e918", () => {
    api.rerender('c7a9e918', render)
  })

}


export default __exports__